export const academic_cals=[
    {
        'id':"8",
        "head":"2026-2027",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/12k5d9kKaY1UkW1CUIGHWjG4LWwNNJPVp/view?usp=drivesdk"
    },

      {
        'id':"7",
        "head":"2025-2026-EVEN SEM",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1UyO_zW2_oK6dH7QArLuz8T_I4nb6K_fl/view?usp=sharing"
    },



    {
        'id':"6",
        "head":"2025-2026-ODD SEM",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1EDGG3P8m9GcyzyyTkdrSRRsGTwWkF-TB/view?usp=drivesdk"
        // "pdf":"https://drive.google.com/file/d/1_Qv3j1NbSnwoFG_6r4v8vxmKQxhDz0IP/view?usp=sharing" this is odd and even  same pdf 
    },
    {
        'id':"5",
        "head":"2024-2025",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/16naf08ToVf0Hjx2S9f0rNaOqfaJH-656/view?usp=sharing"
    },
    {
        'id':"4",
        "head":"2023-2024",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/17fXQlc0LIvynXcFGgBdRtE4KsC7EgsIu/view?usp=sharing"
    },
    {
        'id':"1",
        "head":"2022-2023",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1TnGT1GWi8DhQYioIUJkOs_lbs6IQXH1O/view?usp=drive_link"
    },
    {
        'id':"2",
        "head":"2021-2022",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1Qv13Zr9O8p55xiHEYdYkKX91eurEnnFD/view?usp=drive_link"
    },
    {
        'id':"3",
        "head":"2020-2021",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1GB6yrkLkEM-Djm5HzaGQhsKjVpPxHsgx/view?usp=drive_link"
    },
]
export const graduates_cals=[
    {
        'id':"1",
        "head":"B.E-CIVIL",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1qTJP4s4YSdfUufzL4uh38EkSbFoH01N8/view?usp=drivesdk"
    },

      {
        'id':"2",
        "head":"B.E-MECH",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1qTvEXZAFt1Y5VuLClu5iuL2ZkxH5EhjD/view?usp=drivesdk"
    },



    {
        'id':"3",
        "head":"B.E-EEE",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1qb664BH9mJMwlbjV5ioj87k2WCX9CGdB/view?usp=drivesdk"
        
    },
    {
        'id':"4",
        "head":"B.E-ECE",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1qYpS4Rx0JMeVfuL5byScNs-Xig2d28S8/view?usp=drivesdk"
    },
    {
        'id':"5",
        "head":"B.E-CSE",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1qWnC5jMlDpAdPVYZgMaRooY50i0ZmFZV/view?usp=drivesdk"
    },
    {
        'id':"5",
        "head":"M.E-ENVIRONMENTAL ENGINEERING",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1qlFGbcvTW8eD-tAeCJOAMrxjVqIP7ArS/view?usp=drivesdk"
    },
    {
        'id':"6",
        "head":"M.E-MANUFACTURING ENGINEERING",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1qhgiBBDW9hPOOKsdbn3iOIosoCyAmRdz/view?usp=drivesdk"
    },
    {
        'id':"7",
        "head":"M.E-MICROWAVE & OPTICAL COMMUNICATION",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1qh4GgFMTyMhAKm43BVTPcVTa6YuOSuYS/view?usp=drivesdk"
    },
    {
        'id':"8",
        "head":"M.E-STRUCTURAL ENGINEERING",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1qtIGATST6tfjndrkjGJVxzATG-rQnHuL/view?usp=drivesdk"
    },
    {
        'id':"9",
        "head":"M.E-POWER ELECTRONICS & DRIVES",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1qfX9IO0bUAGtHT5aNhvvJ8Vl9vcPqrEd/view?usp=drivesdk"
    },
    
]